import "core-js/modules/es.array.push.js";
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import { rqtGetCustomerDetail } from '@/services/cms/customer';
import { rqtGetPlace } from '@/services/common/place';
import { initResCodeType, formatSelectColumn } from '@/utils/cpt-cmn';
import { useStore } from 'vuex';
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  setup() {
    const store = useStore();
    const searchForm = {
      id: store.state.account.user.customerId
    };
    const listRequest = rqtGetCustomerDetail;
    const codeResItems = ref([{
      title: '地址类型',
      dataIndex: 'addressType',
      dataType: 'select',
      dataRes: undefined,
      dataResItem: {
        key: 'code',
        title: 'codeName'
      },
      dataResCodeType: 'addressType'
    }]);
    onMounted(() => {
      initResCodeType(codeResItems.value);
    });
    function resultDataFormatter(data) {
      //重新封装一层，要不然页面不刷新，显示不了省市区
      data = reactive(data);
      for (const addr of data.customerAddressList) {
        formatAddr(addr);
      }
      return data.customerAddressList;
    }
    async function formatAddr(addr) {
      if (addr.province) {
        await Promise.all([rqtGetPlace({
          placeType: '01',
          placeCode: addr.province
        }), rqtGetPlace({
          placeType: '02',
          placeCode: addr.city
        }), rqtGetPlace({
          placeType: '03',
          placeCode: addr.country
        })]).then(([res1, res2, res3]) => {
          const resData1 = res1.data.data;
          const resData2 = res2.data.data;
          const resData3 = res3.data.data;
          addr.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join('');
        }).catch(() => {});
      }
    }
    const router = useRouter();
    function onToEditor() {
      router.push('/wx/addr');
    }
    const listViewCptRef = ref(null);
    return {
      searchForm,
      listRequest,
      codeResItems,
      resultDataFormatter,
      onToEditor,
      listViewCptRef,
      formatSelectColumn
    };
  }
};